import * as yup from 'yup';
import dayjs from 'dayjs';
import { maxLengthErrorMessage, requiredErrorMessage } from '../../shared/consts';

const validationSchema = yup.object().shape({
  image_main: yup.mixed().required(requiredErrorMessage),
  name: yup.string().required(requiredErrorMessage).max(100, maxLengthErrorMessage(100)),
  description_short: yup.string().required(requiredErrorMessage).max(200, maxLengthErrorMessage(200)),
  description: yup.string().required(requiredErrorMessage).max(500, maxLengthErrorMessage(500)),
  date_start: yup
    .string()
    .required(requiredErrorMessage)
    .test('date_start', 'Неверная дата', (value) => {
      if (!value) return false;
      return !dayjs(value).isBefore(dayjs(), 'day');
    }),
  date_end: yup
    .string()
    .required(requiredErrorMessage)
    .test('date_end', 'Неверная дата', function (value) {
      const { date_start } = this.parent;
      if (!date_start || !value) {
        return false;
      }
      return dayjs(value).diff(dayjs(date_start), 'day') >= 1;
    }),
  date_award_start: yup.string().required(requiredErrorMessage),
  date_award_end: yup.string().required(requiredErrorMessage),
  objective_id: yup.number().required(requiredErrorMessage),
});

export { validationSchema };
